import { urlConfig } from "../../config/urlConfig";
import { MetaDataItemModel } from "../../types/MetaDataItemModel";
import { postCall } from "../httpService";

export const GetMetaDataItems = async (params: MetaDataItemModel) => {
  try {
    const response = await postCall(urlConfig.DisplayMetaDataItem, params);
    return response.data;
  } catch (error) {
    console.error("Error in GetMetaDataItems", error);
    throw error;
  }
};

export const MetaDataItemStatusChange = async (params: MetaDataItemModel) => {
  try {
    const response = await postCall(urlConfig.MetaDataItemStatusChange, params);
    return response.data;
  } catch (error) {
    console.error("Error in MetaDataItemStatusChange", error);
    throw error;
  }
};

export const EditMetaDataItem = async (params: MetaDataItemModel) => {
  try {
    const response = await postCall(urlConfig.MetaDataItemEdit, params);
    return response.data;
  } catch (error) {
    console.error("Error in EditMetaDataItem", error);
    throw error;
  }
};

export const SaveMetaDataItem = async (params: MetaDataItemModel) => {
  try {
    const response = await postCall(urlConfig.MetaDataItemInsert, params);
    return response.data;
  } catch (error) {
    console.error("Error in SaveMetaDataItem", error);
    throw error;
  }
};
